import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import { geoQueryKeys } from '@/queries/geo-library/geo.keys';

export const geoQueries = {
  registry: () =>
    queryOptions({
      queryKey: geoQueryKeys.geoLibrary,
      queryFn: () => api.geo.getGeoLibrary(),
      staleTime: 1000 * 60 * 60 * 24, // 24 hours
    }),
};

export const useGeoLibraryQuery = () => {
  return useQuery(geoQueries.registry());
};
